(function () {
  'use strict';
  if (window.minetanInitNavigationDialogs) return;

  var active = null;
  var menu = null;
  var menuAPI = null;
  var menuOpener = null;
  var regionRequest = null;
  var skipMenuReturn = false;
  var text = window.minetanNavigationText || {};

  function each(nodes, callback) { Array.prototype.forEach.call(nodes, callback); }
  // Share the existing drawer hiding behavior, including asynchronous app controls.
  window.minetanFloatingWidgets = (function () {
    var owners = 0;
    var originals = new Map();
    var roots = new WeakSet();
    var observer = new MutationObserver(function (records) {
      if (owners && records.some(function (record) {
        return record.type === 'childList' || originals.has(record.target);
      })) hidePresent();
    });
    var options = { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] };

    function hide(element) {
      if (!originals.has(element)) {
        originals.set(element, { value: element.style.getPropertyValue('display'),
          priority: element.style.getPropertyPriority('display') });
      }
      if (element.style.getPropertyValue('display') !== 'none' ||
          element.style.getPropertyPriority('display') !== 'important') {
        element.style.setProperty('display', 'none', 'important');
      }
    }
    function hidePresent() {
      each(document.querySelectorAll(
        '#onetrust-consent-sdk,.acsb-trigger,[part="acsb-trigger"],.embeddedServiceHelpButton,' +
        '#cmpboxrecall,#chat-bubble-root,access-widget-ui,tolstoy-widget,' +
        'tolstoy-widget > button,button[aria-label="Open the shopping assistant"]'
      ), hide);
      each(document.querySelectorAll('access-widget-ui,#chat-bubble-root'), function (host) {
        var root = host.shadowRoot;
        if (!root) return;
        if (!roots.has(root)) {
          observer.observe(root, options);
          roots.add(root);
        }
        var button = root.querySelector('[part~="acsb-trigger"]') || root.querySelector('button');
        if (button) hide(button);
      });
    }
    return {
      hide: function () {
        if (owners++ === 0) observer.observe(document.documentElement, options);
        hidePresent();
        var restored = false;
        return function () {
          if (restored) return;
          restored = true;
          // Overlapping drawers must not restore controls while another is open.
          if (--owners) return;
          observer.disconnect();
          originals.forEach(function (original, element) {
            if (original.value) element.style.setProperty('display', original.value, original.priority);
            else element.style.removeProperty('display');
          });
          originals.clear();
          roots = new WeakSet();
        };
      }
    };
  })();
  function setInert(element, value) {
    // Keep the retained Salesforce polyfill's tab-stop bookkeeping in sync.
    var descriptor = Object.getOwnPropertyDescriptor(Element.prototype, 'inert');
    if (descriptor && descriptor.set) descriptor.set.call(element, value);
    else element.inert = value;
  }
  function visible(element) {
    return element && element.isConnected && !element.disabled &&
      !element.closest('[inert]') && element.getClientRects().length > 0 &&
      getComputedStyle(element).visibility !== 'hidden';
  }
  function focusable(element) {
    return Array.prototype.filter.call(element.querySelectorAll(
      'a[href],button,input,select,textarea,[tabindex]'
    ), function (item) { return item.tabIndex >= 0 && visible(item); });
  }
  function firstFocus() {
    if (!active) return;
    var close = active.element.querySelector(active.type === 'menu' ? '.close-menu' : '.close-quickview');
    (visible(close) ? close : focusable(active.element)[0] || active.element).focus();
  }
  function menuTriggers() { return document.querySelectorAll('a[href="#mmenu"]'); }
  function expanded(value) {
    each(menuTriggers(), function (trigger) {
      trigger.setAttribute('aria-controls', 'mmenu');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', String(value));
      if (!trigger.getAttribute('aria-label')) trigger.setAttribute('aria-label', text.openMenu || 'Open menu');
    });
  }
  function hideWidgets(state) {
    state.restoreWidgets = window.minetanFloatingWidgets.hide();
  }
  function activate(element, type, opener) {
    if (active && active.element === element) return;
    setInert(element, false);
    element.setAttribute('aria-hidden', 'false');
    element.setAttribute('aria-modal', 'true');
    active = { element: element, type: type, opener: opener, lastFocus: null, background: [], suspendedInert: [], overflow: document.body.style.overflow };
    var branch = element;
    while (branch && branch.parentElement) {
      each(branch.parentElement.children, function (sibling) {
        if (sibling === branch || sibling.matches('script,style,link,#mm-blocker,#quickViewOverlay_CountrySelector') || sibling.hasAttribute('inert')) return;
        // Avoid overlapping inert roots: the legacy polyfill otherwise remembers
        // the already-disabled tab stops of closed drawers and cannot restore them.
        each(sibling.querySelectorAll('[inert]'), function (nested) {
          active.suspendedInert.push(nested);
          setInert(nested, false);
        });
        setInert(sibling, true);
        active.background.push(sibling);
      });
      branch = branch.parentElement;
      if (branch === document.body) break;
    }
    hideWidgets(active);
    if (type === 'region') document.body.style.overflow = 'hidden';
    firstFocus();
  }
  function deactivate(restoreFocus) {
    if (!active) return;
    var state = active;
    active = null;
    each(state.background, function (element) { setInert(element, false); });
    each(state.suspendedInert, function (element) { setInert(element, true); });
    if (state.restoreWidgets) state.restoreWidgets();
    if (state.type === 'region') document.body.style.overflow = state.overflow;
    state.element.removeAttribute('aria-modal');
    state.element.setAttribute('aria-hidden', 'true');
    if (restoreFocus) {
      var target = state.opener;
      if (!visible(target)) {
        var candidates = state.type === 'region' ? document.querySelectorAll('a[href*="choose-country"],a[href="#mmenu"]') : menuTriggers();
        target = Array.prototype.filter.call(candidates, visible)[0];
      }
      if (target) target.focus({ preventScroll: true });
    }
    // Closed panels are already display:none. Do not add another inert root:
    // other drawers can temporarily inert their ancestor through the chat polyfill.
  }
  function closeRegion(restoreFocus) {
    var region = document.getElementById('quickViewResponseData_CountrySelector');
    var overlay = document.getElementById('quickViewOverlay_CountrySelector');
    if (region) region.style.display = 'none';
    if (overlay) overlay.style.display = 'none';
    if (active && active.type === 'region') deactivate(restoreFocus);
  }
  function showRegion(opener) {
    var region = document.getElementById('quickViewResponseData_CountrySelector');
    if (!region) return;
    region.style.display = 'block';
    var overlay = document.getElementById('quickViewOverlay_CountrySelector');
    if (overlay) overlay.style.display = 'block';
    activate(region, 'region', opener);
  }
  function openRegion(opener) {
    if (!document.getElementById('quickViewResponseData_CountrySelector')) return false;
    if (active && active.type === 'menu') {
      // Finish the existing close animation and release its inert layer first.
      regionRequest = menu.contains(opener) ? menuOpener : opener;
      skipMenuReturn = true;
      menuAPI.close();
    } else showRegion(opener);
    return true;
  }

  window.minetanInitNavigationDialogs = function () {
    text = window.minetanNavigationText || text;
    var region = document.getElementById('quickViewResponseData_CountrySelector');
    if (region) {
      region.setAttribute('role', 'dialog');
      region.setAttribute('tabindex', '-1');
      if (!active || active.element !== region) {
        region.setAttribute('aria-hidden', 'true');
      }
    }
    menu = document.getElementById('mmenu');
    var api = menu && window.jQuery && jQuery(menu).data('mmenu');
    if (!api || api === menuAPI) return;
    menuAPI = api;
    menu.setAttribute('role', 'dialog');
    menu.setAttribute('aria-label', text.menu || 'Menu');
    menu.setAttribute('tabindex', '-1');
    menu.setAttribute('aria-hidden', 'true');
    each(menu.querySelectorAll('.close-menu'), function (close) {
      close.setAttribute('aria-label', text.closeMenu || 'Close menu');
    });
    expanded(false);
    api.bind('open:start', function () {
      if (active && active.type === 'region') closeRegion(false);
      menuOpener = menuOpener || document.activeElement;
      skipMenuReturn = false;
      expanded(true);
      activate(menu, 'menu', menuOpener);
    });
    api.bind('open:finish', function () {
      if (active && active.type === 'menu' && !menu.contains(document.activeElement)) firstFocus();
    });
    api.bind('close:finish', function () {
      expanded(false);
      if (active && active.type === 'menu') deactivate(!skipMenuReturn);
      menuOpener = null;
      if (regionRequest) {
        var opener = regionRequest;
        regionRequest = null;
        showRegion(opener);
      }
    });
  };

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('a[href="#mmenu"]');
    if (trigger) menuOpener = trigger;
    var country = event.target.closest('a[href*="choose-country"]');
    if (country && openRegion(country)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    var close = event.target.closest('#quickViewResponseData_CountrySelector .close-quickview');
    if (close || event.target.id === 'quickViewOverlay_CountrySelector') {
      event.preventDefault();
      closeRegion(true);
    }
  }, true);
  // Run before the accessibility widget's document-level keyboard handlers.
  window.addEventListener('keydown', function (event) {
    if (!active) return;
    if (event.key === 'Escape') {
      document.documentElement.setAttribute('data-focus-modality', 'keyboard');
      event.preventDefault();
      event.stopImmediatePropagation();
      if (active.type === 'menu') menuAPI.close();
      else closeRegion(true);
    } else if (event.key === 'Tab' && !event.altKey && !event.ctrlKey && !event.metaKey) {
      // Own every Tab step while the dialog is open. The accessibility widget's
      // global shortcut handler otherwise cancels middle steps and keeps focus
      // on Close, even though the menu links themselves are focusable.
      document.documentElement.setAttribute('data-focus-modality', 'keyboard');
      event.preventDefault();
      event.stopImmediatePropagation();
      var items = focusable(active.element);
      if (!items.length) {
        active.element.focus({ preventScroll: true });
        return;
      }
      var index = items.indexOf(document.activeElement);
      var next = index < 0 ? (event.shiftKey ? items.length - 1 : 0) :
        (index + (event.shiftKey ? -1 : 1) + items.length) % items.length;
      // Let the browser scroll long menus to the newly focused control.
      items[next].focus();
    }
  }, true);
  document.addEventListener('focusin', function (event) {
    if (!active) return;
    if (active.element.contains(event.target)) {
      active.lastFocus = event.target;
      return;
    }
    if (event.target.closest('[data-kl-scroll-locking-modal]')) {
      // A timed signup dialog has taken over. Release navigation's focus trap
      // instead of pulling the customer back to Close behind that dialog.
      if (active.type === 'menu') {
        skipMenuReturn = true;
        regionRequest = null;
        deactivate(false);
        menuAPI.close();
      } else closeRegion(false);
      return;
    }
    // Ignore stray widget focus without losing the customer's place in the menu.
    if (visible(active.lastFocus)) active.lastFocus.focus();
    else firstFocus();
  });
  document.addEventListener('shopify:section:load', window.minetanInitNavigationDialogs);
  if (window.jQuery) jQuery(window.minetanInitNavigationDialogs);
  else document.addEventListener('DOMContentLoaded', window.minetanInitNavigationDialogs);
})();
